export default "__VITE_ASSET__DKBH_CmZ__"